import {
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    OnDestroy,
    OnInit,
    ViewChild,
} from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import FileSaver from 'file-saver';
import { ToastrService } from 'ngx-toastr';
import { Observable, Subject, Subscription } from 'rxjs';
import { distinctUntilChanged, debounceTime, takeUntil, tap } from 'rxjs/operators';
import Swal from 'sweetalert2';

import { debounceConfig } from '@app/core/_config';
import { EExports } from '@app/core/_constant/exports.constants';
import {
    InventoryStockType,
    StockSortingType,
    SkuStockSortType,
    FileTypeConstant,
} from '@app/core/_constant/index.constants';
import {
    ProductTypeConstant,
    ProductTypes,
} from '@app/core/_constant/product-type.constants';
import { MirrorInventoryFromParent } from '@app/core/_constant/product.constants';
import { ViewAccountOnly } from '@app/core/_constant/user-account.constants';
import { AuthService } from '@app/core/auth';
import { PermissionService } from '@app/core/auth/services/permission.service';
import { Rfq } from '@app/core/locations/store/locations.model';
import { ProductTagService } from '@app/core/product-tags/services/product-tag.service';
import { RFQ, RfqService } from '@app/core/quotes';
import { ExportTemplateRfqService } from '@app/core/quotes/services/export-template-rfq.service';
import { SettingConstant } from '@app/core/settings/constants/settings.constant';
import { SettingsService } from '@app/core/settings/services/settings.service';
import { ShippingCarrierService } from '@app/core/shipping-carriers/services/shipping-carrier.service';
import { EFeatureFlag } from '@app/feature-toggle-list';
import { DynamicFiltersComponent } from '@app/shared/components/dynamic-filters/dynamic-filters.component';
import { ExportRfqService } from '@app/shared/services/export-rfq.service';
import { FeatureToggleService } from '@app/shared/services/feature-toggle.service';
import { LocalStorageService } from '@app/shared/services/local-storage.service';
import {
    ECustomFieldObject,
    ICustomField,
} from 'v2/modules/custom-field/interfaces/custom-field.interface';
import { RfqInventoryOrdersTableComponent } from 'v2/modules/rfq/components/rfq-inventory-orders-table/rfq-inventory-orders-table.component';
import { DialogConfig } from 'v2/modules/shared/configs/dialog.config';
import { CustomFieldApiService } from 'v2/modules/shared/services/api/custom-field-api.service';
import { RfqApiService } from 'v2/modules/shared/services/api/rfq/rfq-api.service';
import { LoadingDialogUtilService } from 'v2/modules/shared/services/util/loading-dialog-util.service';
import { trackById } from 'v2/modules/shared/util/track-by.util';
import { UiMultipleConfirmationDialogComponent } from 'v2/modules/ui/components/ui-multiple-confirmation-dialog/ui-multiple-confirmation-dialog.component';

import { BulkUpdateClientRfqFormComponent } from '../../bulk-update-client-rfq-form/bulk-update-client-rfq-form.component';
import { ConsolidateMasterSkuComponent } from '../../consolidate-master-sku/consolidate-master-sku.component';
import { CreateClientRfqComponent } from '../../create-client-rfq/create-client-rfq.component';
import { QuotationPopupFormComponent } from '../../quotation-popup-form/quotation-popup-form.component';
import { RfqClientProfileComponent } from '../../rfq-client-profile/rfq-client-profile.component';
import { RfqClientsPopupFormComponent } from '../../rfq-clients-popup-form/rfq-clients-popup-form.component';
import { RfqFactoryAdminAssignmentComponent } from '../../rfq-factory-admin-assignment/rfq-factory-admin-assignment.component';
import { UpdateRfqLocationsComponent } from '../../update-rfq-locations/update-rfq-locations.component';
import { AdjustmentEntryFormComponent } from '../adjustment-entry-form/adjustment-entry-form.component';
import { ExportTemplateRfqComponent } from '../export-template-rfq/export-template-rfq.component';
import { SkuDuplicateReportComponent } from '../sku-duplicate-report/sku-duplicate-report.component';
import { SkuStockDetailsComponent } from '../sku-stock-details/sku-stock-details.component';

import { EItemType } from './../../../../../v2/modules/order/interfaces/order.interface';
import { invListFilterConfig } from './inv-list.filter-config';

enum ExportType {
  PDF = 'Export to PDF',
  ALTERNATE_SKU_PDF = 'Export Alternate SKUs to PDF',
  FULL_MASTER_SKU_EXCEL = 'Export Full Master SKUs to Excel',
  MASTER_SKU_EXCEL = 'Export Master SKUs to Excel',
  VARIANT_SKU_DETAILS_EXCEL = 'Export Variant SKU Details to Excel',
  MASTER_SKU_DETAILS_EXCEL = 'Export Master SKU Details to Excel',
  ALTERNATE_SKU_EXCEL = 'Export Alternate SKUs to Excel',
  VARIANT_SKU_EXCEL = 'Export Variant SKUs to Excel',
  ALTERNATE_SKU_CSV = 'Export Alternate SKUs to CSV',
  EXPORT_TEMPLATE_SKU = 'Export Template SKUs',
  SKU_WITH_CUSTOM_FIELDS_EXCEL = 'Export SKU with Custom Fields to Excel',
  SKU_WITH_CUSTOM_FIELDS_CSV = 'Export SKU with Custom Fields to CSV',
}
@Component({
  selector: 'cnc-inv-list',
  templateUrl: './inv-list.component.html',
  styleUrls: ['./inv-list.component.scss'],
})
export class InvListComponent implements OnInit, AfterViewInit, OnDestroy {
  length = 0;
  pageSize = 20;
  pageSizeOptions: number[] = [5, 10, 20, 25, 100];
  pageTitle: string = this.translate.instant('TITLES.REQUEST_FOR_QUOTES');

  checked: any = [];
  checkedAll: boolean = false;
  checkedCount: number = 0;

  tags: any[] = [];

  settings: any = {};
  shippingCarriers: any[] = [];

  exportType = ExportType;
  totalRfqsCount: number = 0;

  rfqRecord: any = { data: [] };
  variantParentSub: Subscription;
  variantParentSkus: number[] = [];
  exactMatch: boolean;

  productTypes = ProductTypes;
  featureFlag = EFeatureFlag;

  unsubscribeTotalSkuToExport: Subscription;

  eItemType = EItemType;
  trackById = trackById;

  @ViewChild(DynamicFiltersComponent) dynamicFilterComponent;
  filterQuery: Record<string, any> = {};
  filterConfiguration = invListFilterConfig;

  public columns: Record<string, DynamicColumnConfig> = {
    createdDate: {
      label: 'Created Date/Time',
      active: false,
    },
    sku: { label: 'SKU', active: true },
    productName: { label: 'Product', active: true },
    productImage: { label: 'Product Image', active: true },
    upc: { label: 'UPC', active: false },
    location: { label: 'Location', active: true },
    incoming: { label: 'Incoming', active: true },
    onHand: { label: 'On-hand', active: true },
    pending: { label: 'Pending', active: true },
    available: { label: 'Available', active: true },
    sourcingAssignees: { label: 'Sourcing assignees', active: false },
    wholesalePrice: { label: 'Wholesale price', active: false },
    unitCost: { label: 'Unit cost', active: false },
    category: { label: 'Category', active: false },
    subCategory: { label: 'Sub Category', active: false },
    tags: { label: 'Tags', active: false },
    kitItems: { label: 'Kit Items', active: false },
    uom: { label: 'UOM', active: true },
  };

  private metaLS = 'meta_quotes/inventory/list';
  params: any = {
    per_page: 20,
    page: 1,
  };

  productSku: Subscription;
  isLoadingRecords: boolean = false;
  toggleRfqStarred: Subscription;
  private onDestroy$ = new Subject();
  firstCheckedRfqId: number = 0;
  featureFlags: { [key: string]: boolean };
  customFields: ICustomField[] = [];
  companyLogo: string = '';
  eExportsConstant = EExports;

  constructor(
    private activeRoute: ActivatedRoute,
    public authService: AuthService,
    public rfqService: RfqService,
    private modalSvc: NgbModal,
    private translate: TranslateService,
    private dialog: MatDialog,
    private router: Router,
    public exportRfq: ExportRfqService,
    public exportTemplateRfq: ExportTemplateRfqService,
    public settingsSvc: SettingsService,
    private toastr: ToastrService,
    private tagSvc: ProductTagService,
    private cd: ChangeDetectorRef,
    private shippingCarrierSvc: ShippingCarrierService,
    public UserPermission: PermissionService,
    private localStorageService: LocalStorageService,
    private featureToggleService: FeatureToggleService,
    private customFieldApiService: CustomFieldApiService,
    private snackBar: MatSnackBar,
    private rfqApiService: RfqApiService,
    private loadingDialogService: LoadingDialogUtilService,
  ) {
    this.getMypermissions().subscribe();
  }

  ngOnInit() {
    const params = this.localStorageService.get(this.metaLS);
    if (params) {
      this.params = params;
    }

    this.initFeatureFlags();

    this.settingsSvc.masterfile$.subscribe((set: any) => {
      this.settings = set;
    });

    this.rfqService.record$.subscribe((resp) => {
      if (resp && resp.data) {
        this.rfqRecord = resp;
        // check if result is in variant then expand the list
        this.tryExpandList();
        this.cd.markForCheck();
      }
    });

    this.getTotalSkuToExport();
    this.tagSvc.getTags({ parent_only: true }, null);

    this.tagSvc.record$.subscribe((tags) => (this.tags = tags));
    this.shippingCarrierSvc.shippingCarriers$.subscribe((res) => {
      if (res.data) {
        this.shippingCarriers = res.data.map((d) => ({
          id: d.id,
          name: d.carrier_name,
        }));
      }
    });

    this.updateFilters();
    this.updateColumns();
    this.loadCustomFields();
    this.initLogoFromSettings().subscribe();
  }

  private getMypermissions(): Observable<any> {
    return this.UserPermission.rPermissions$.pipe(
      tap((response) => {
        const unitCostPermissionLength: number = Object.keys(response).filter(
          (item) => item === 'skuUnitCost.read',
        ).length;
        this.detachColumn(unitCostPermissionLength);
      }),
      takeUntil(this.onDestroy$),
    );
  }

  private detachColumn(unitCostPermissionLength: number): void {
    if (unitCostPermissionLength === 0) {
      const prop = 'unitCost';
      delete this.columns[prop];
    }
  }

  private getTotalSkuToExport(): void {
    this.unsubscribeTotalSkuToExport = this.rfqService
      .getV2Skus({ product_type_id: 2 })
      .subscribe((resp) => {
        if (resp) {
          this.totalRfqsCount = resp['total'];
        }
      });
  }

  ngAfterViewInit() {
    this.onQueryChange(this.dynamicFilterComponent.buildQuery());
  }

  ngOnDestroy(): void {
    this.variantParentSub?.unsubscribe();
    this.productSku?.unsubscribe();
    this.unsubscribeTotalSkuToExport?.unsubscribe();
    this.toggleRfqStarred?.unsubscribe();
    this.onDestroy$.next(null);
    this.onDestroy$.complete();
  }

  columnActive(key: string): boolean {
    if (!this.columns[key]) {
      return false;
    }

    return this.columns[key].active;
  }

  columnLabel(key: string): string {
    if (!this.columns[key]) {
      throw Error(`Column key doesn't exist.`);
    }

    return this.columns[key].label;
  }

  onQueryChange(query: Record<string, any>): void {
    this.filterQuery = query;
    this.params.page = 1;
    this.getRecords(false);
  }

  getVariantSkusByParentIds(parentSkus: any) {
    if (!Array.isArray(parentSkus)) {
      return;
    }
    const nextParams = { ...this.params, ...this.filterQuery };

    this.variantParentSub?.unsubscribe();
    const skuIds: number[] = [];
    parentSkus.forEach((sku: any) => {
      sku.gettingVariantSKUs = true;
      skuIds.push(sku.id);
    });
    this.variantParentSub = this.rfqService
      .getVariantSkusByParentIds(skuIds, nextParams)
      .subscribe((variantSkus: any) => {
        parentSkus.forEach((parentSku: any) => {
          parentSku.variant_skus = variantSkus.filter(
            (vsku: any) => vsku.variant_parent_id == parentSku.id,
          );
          parentSku.variant_skus.forEach((vsku: any) => {
            vsku.unit_costs = this.rfqService.getSkuUnitCosts(vsku);
            const variantIndexValue = vsku.internal_sku.split('-');
            vsku.variantIndexValue = Number(variantIndexValue[1]);
            // try to check row
            this.checked[vsku.id] = this.checked[parentSku.id];
          });
          parentSku.variant_skus.sort(
            (
              firstValue: { variantIndexValue: number },
              secondValue: { variantIndexValue: number },
            ) =>
              firstValue.variantIndexValue < secondValue.variantIndexValue ? -1 : 1,
          );
          this.countChecked();
          this.tryMatchVariantSkus(parentSku.variant_skus);
          parentSku.expanded = true;
          parentSku.gettingVariantSKUs = false;
        });
        this.cd.detectChanges();
      });
  }

  setOrder(order: string) {
    const _SORT_1 = StockSortingType.DESC;
    const _SORT_2 = StockSortingType.ASC;

    // Sort Default Direction
    if (this.params?.order !== order) {
      this.params.order = order;
      this.params.sort = _SORT_1;
    }
    // Flip Sort Direction
    else if (this.params.sort === _SORT_1) {
      this.params.sort = _SORT_2;
    }
    // Stop Sorting
    else {
      delete this.params.order;
      delete this.params.sort;
    }

    this.params.page = 1;

    this.localStorageService.save(this.metaLS, this.params);
    this.getRecords(false);
  }

  getVariantSkusByChunk() {
    const chunks: any = this.variantParentSkus.reduce((all, one, i) => {
      const ch = Math.floor(i / 10);
      all[ch] = [].concat(all[ch] || [], one);

      return all;
    }, []);
    chunks.forEach((skus: any) => {
      this.getVariantSkusByParentIds(skus);
    });
    this.variantParentSkus = [];
  }

  tryExpandList() {
    if (
      !this.filterQuery.sku &&
      !this.filterQuery.product &&
      !this.filterQuery.product_tags
    ) {
      return;
    }
    if (!this.rfqRecord || !this.rfqRecord.data) {
      return;
    }
    // check if sku or product being searched is in the parent skus
    this.variantParentSkus = [];
    this.rfqRecord.data.forEach((row: any) => {
      row.pendingQuantity =
        row.stock && row.stock.qty_pending ? row.stock.qty_pending : 0;

      row.skuMatched =
        this.isSkuMatched(this.filterQuery.sku, row) ||
        this.isUPCMatched(this.filterQuery.sku, row) ||
        this.isSkuMatched(this.filterQuery.product, row) ||
        this.isProductNameMatched(this.filterQuery.sku, row) ||
        this.isProductNameMatched(this.filterQuery.product, row) ||
        this.isProductTagMatched(this.filterQuery.product_tags, row);
      if (!row.skuMatched && !row.variant_skus && row.variant_skus_count > 0) {
        // row.gettingVariantSKUs = true;
        // this.getVariantSkus(row);
        this.variantParentSkus.push(row);
      } else if (row.variant_skus) {
        row.expanded = true;
        this.tryMatchVariantSkus(row.variant_skus);
      }
    });
    this.getVariantSkusByChunk();
  }

  tryMatchVariantSkus(variantSkus) {
    const filteredSKU = this.filterQuery.sku ? this.filterQuery.sku : false;
    const filteredProduct = this.filterQuery.product
      ? this.filterQuery.product
      : false;
    const filteredTag = this.filterQuery.product_tags
      ? this.filterQuery.product_tags
      : false;
    let urlArray: string[] = [];
    let dataUrl: string = '';
    let dataUrlValue: string = '';

    if (this.validateURL(filteredSKU)) {
      urlArray = this.filterQuery.sku.split('quotes/');
      dataUrl = urlArray[urlArray.length - 1];
      dataUrlValue = dataUrl.split('/view')[0];
    }

    if (!Array.isArray(variantSkus)) {
      return;
    }
    variantSkus.forEach((row) => {
      row.pendingQuantity =
        row.stock && row.stock.qty_pending ? row.stock.qty_pending : 0;

      row.skuMatched =
        this.isSkuMatched(filteredSKU, row) ||
        this.isUPCMatched(filteredSKU, row) ||
        this.isURLMatched(dataUrlValue, row) ||
        this.isProductNameMatched(filteredProduct, row) ||
        this.isProductTagMatched(filteredTag, row);
      row.skuExactWordMatch =
        this.rfqRecord.data &&
        this.rfqRecord.data.length === 1 &&
        variantSkus.length === 1
          ? true
          : this.exactMatch;
    });
  }

  private exactMatchData(keyword: string, data: any): void {
    this.exactMatch =
      data && data.trim().toLowerCase() === keyword.trim().toLowerCase();
  }

  private arrayMatchTagData(list: string[], data: any): void {
    this.exactMatch = data.every((row) => list.includes(row.tag_id.toString()));
  }

  isSkuMatched(keyword: string, rfqRow: any) {
    if (!keyword) {
      return false;
    }
    const skuList = [rfqRow.internal_sku.trim().toLowerCase()].concat(
      rfqRow.alternate_skus
        ? rfqRow.alternate_skus.map((sku) => sku.alternate_sku.trim().toLowerCase())
        : [],
    );
    const filteredSkuList = skuList.find(
      (sku) => sku.indexOf(keyword.trim().toLowerCase()) >= 0,
    );

    this.exactMatchData(keyword, filteredSkuList);

    return !!filteredSkuList;
  }

  isProductNameMatched(keyword: string, rfqRow: any) {
    if (!keyword) {
      return false;
    }
    this.exactMatchData(keyword, rfqRow.product_name);

    return (
      rfqRow.product_name
        .trim()
        .toLowerCase()
        .indexOf(keyword.trim().toLowerCase()) >= 0
    );
  }

  isProductTagMatched(keyword: string, rfqRow: any): boolean {
    if (!keyword) {
      return false;
    }

    const productTags =
      typeof keyword === 'string' ? keyword.split(',') : [`${keyword}`]; // ie. keyword was a single numeric ID (typeof === number)
    this.arrayMatchTagData(productTags, rfqRow.tags);

    return rfqRow.tags.some((row) => productTags.includes(row.tag_id.toString()));
  }

  isUPCMatched(keyword: string, rfqRow: any): boolean {
    if (!keyword) {
      return false;
    }

    if (rfqRow.upc) {
      this.exactMatchData(keyword, rfqRow.upc);

      return (
        rfqRow.upc.trim().toLowerCase().indexOf(keyword.trim().toLowerCase()) >= 0
      );
    }
  }

  isURLMatched(keyword: string, rfqRow: any): boolean {
    if (keyword === '') {
      return false;
    }

    if (rfqRow.id) {
      this.exactMatchData(keyword, rfqRow.id);

      return (
        rfqRow.id
          .toString()
          .trim()
          .toLowerCase()
          .indexOf(keyword.trim().toLowerCase()) >= 0
      );
    }
  }

  validateURL(link: string): boolean {
    if (!link) {
      return false;
    }

    return link.indexOf('http://') === 0 || link.indexOf('https://') === 0
      ? true
      : false;
  }

  addQuotation(rfq: RFQ) {
    this.showQuotationForm(rfq);
  }

  showQuotationForm(rfq: RFQ, quotation?: any) {
    const modalRef = this.modalSvc.open(QuotationPopupFormComponent, {
      size: 'lg',
      windowClass: 'xl1024',
    });
    modalRef.componentInstance.rfq = rfq;
    if (quotation) {
      modalRef.componentInstance.quotation = quotation;
    }
  }

  showDetails(e: Event, rfq: RFQ, v?: string) {
    e.preventDefault();

    this.rfqService.setActive(rfq, true);

    if (v) {
      this.router.navigate(['inventory', rfq.id, 'view'], {
        queryParams: { v: v },
      });
    } else {
      this.router.navigate(['inventory', rfq.id, 'view']);
    }
  }

  assignSelected() {
    const rfq_ids = [];
    this.checked.forEach((v, idx) => {
      if (v) {
        rfq_ids.push(idx);
      }
    });
    const modalRef = this.modalSvc.open(RfqFactoryAdminAssignmentComponent, {});
    modalRef.componentInstance.rfq_ids = rfq_ids;
    modalRef.result.then(
      () => {
        this.checkedAll = false;
        this.checkAll();
      },
      (error) => {},
    );
  }

  gotoPurchaseOrders(rfq) {
    this.router.navigateByUrl('/orders?sku=' + rfq.internal_sku);
  }

  assignSalesMembers() {
    const rfq_ids = [];
    this.checked.forEach((v, idx) => {
      if (v) {
        rfq_ids.push(idx);
      }
    });
    const modalRef = this.modalSvc.open(RfqFactoryAdminAssignmentComponent, {});
    modalRef.componentInstance.role = 2;
    modalRef.componentInstance.rfq_ids = rfq_ids;
    modalRef.result.then(
      () => {
        this.checkedAll = false;
        this.checkAll();
      },
      (error) => {},
    );
  }

  countChecked() {
    this.checkedCount = this.checked.filter((x) => {
      return x;
    }).length;
  }

  checkAll() {
    if (!this.checkedAll) {
      this.checked = [];
      this.countChecked();
      this.cd.detectChanges();

      return;
    }
    this.variantParentSkus = [];
    this.rfqRecord.data.forEach((row: any) => {
      this.checked[row.id] = this.checkedAll;
      if (!row.variant_skus && row.variant_skus_count > 0) {
        // this.toggleVariantSku(row);
        this.variantParentSkus.push(row);
      } else if (row.variant_skus) {
        row.expanded = true;
        row.variant_skus.forEach((vsku: any) => {
          this.checked[vsku.id] = this.checked[row.id];
        });
      }
    });
    this.getVariantSkusByChunk();
    this.countChecked();
    this.cd.detectChanges();
  }

  toggleVariantSku(parentRfq: any) {
    if (parentRfq.expanded) {
      parentRfq.expanded = !parentRfq.expanded;
      parentRfq.variant_skus.forEach((vsku: any) => {
        this.checked[vsku.id] = this.checked[parentRfq.id];
      });
      this.countChecked();
      this.cd.detectChanges();
    } else {
      if (!parentRfq.expanded) {
        parentRfq.expanded = true;
        if (!parentRfq.variant_skus) {
          this.variantParentSkus = [parentRfq];
          this.getVariantSkusByChunk();
        }
      }
    }
  }

  toggleCheckbox(parentRfq: any): void {
    if (this.checkedCount === 0) {
      this.firstCheckedRfqId = parentRfq.id;
    }

    if (!parentRfq.expanded && this.checked[parentRfq.id]) {
      this.toggleVariantSku(parentRfq);
      this.countChecked();
      this.cd.detectChanges();

      return;
    }

    if (parentRfq.variant_skus && parentRfq.variant_skus.length) {
      parentRfq.variant_skus.forEach((vsku: any) => {
        this.checked[vsku.id] = this.checked[parentRfq.id];
      });
    }

    this.countChecked();
    this.cd.detectChanges();
  }

  toggleSkuWithVariant(parentRfq: any, boolState: boolean): void {
    this.checked[parentRfq.id] = boolState;
    parentRfq.expanded = true;

    if (parentRfq.variant_skus && parentRfq.variant_skus.length > 0) {
      parentRfq.variant_skus.forEach((vsku: any) => {
        this.checked[vsku.id] = boolState;
      });
    }

    this.countChecked();
    this.cd.detectChanges();
  }

  assignRFQ(rfq: RFQ) {
    this.rfqService.setActive(rfq, true);
    const modalRef = this.modalSvc.open(RfqFactoryAdminAssignmentComponent, {});
    modalRef.componentInstance.rfq = rfq;
  }

  viewClientInfo(rfq: RFQ) {
    this.rfqService.setActive(rfq, true);
    const modalRef = this.modalSvc.open(RfqClientProfileComponent, {});
    modalRef.componentInstance.rfq = rfq;
  }

  editRfq(rfq: any) {
    const modalRef = this.modalSvc.open(CreateClientRfqComponent, {
      size: 'lg',
      windowClass: 'xl1024',
    });
    modalRef.componentInstance.rfq = rfq;
    modalRef.result.then((resp) => {
      if (resp) {
        this.rfqService.refreshList();
      }
    });
  }

  onPaginationChange(data): void {
    this.params.page = data.pageIndex + 1;
    this.params.per_page = data.pageSize;
    this.localStorageService.save(this.metaLS, this.params);
    this.checkedAll = false;
    this.getRecords(true);
  }

  getRecords(scrollTo: boolean, params: Record<string, any> = {}) {
    const { page = this.params.page, paramsOnly, exportType } = params;
    this.params.product_type_id = 2;
    this.params.group_variant = 1;

    if (exportType) {
      switch (exportType) {
        case ExportType.VARIANT_SKU_EXCEL:
          delete this.params.group_variant;
          this.params.variant_only = 1;
          break;
        case ExportType.VARIANT_SKU_DETAILS_EXCEL:
          delete this.params.group_variant;
          this.params.variant_only = 1;
          break;
        case ExportType.FULL_MASTER_SKU_EXCEL:
          delete this.params.group_variant;
          break;
        default:
          delete this.params.variant_only;
          break;
      }
    }

    if (this.filterQuery.product_type_id === '0') {
      delete this.filterQuery.product_type_id;
    }

    const nextParams = { ...this.params, ...this.filterQuery, page };
    if (paramsOnly) {
      return nextParams;
    } else {
      this.rfqService.setParams(nextParams);
      this.refreshSkuList(nextParams);

      if (scrollTo) {
        const el = document.getElementById('scroll-top-pagination');
        el?.scrollIntoView({ block: 'start', behavior: 'smooth' });
      }
    }
  }

  refreshSkuList(params: any): void {
    this.productSku?.unsubscribe();
    this.isLoadingRecords = true;
    this.productSku = this.rfqService
      .getV2Skus(params)
      .pipe(debounceTime(debounceConfig.time), distinctUntilChanged())
      .subscribe((skus: any) => {
        this.rfqRecord = skus;
        this.rfqRecord.data.forEach((row: any) => {
          row.pendingQuantity =
            row.stock && row.stock.qty_pending ? row.stock.qty_pending : 0;
          if (row.variant_parent_id === 0) {
            this.calculateTotalVariantSkuStocks(row);
          }
          row.hasValidProductImage = this.isValidLink(row?.photo);
        });
        this.tryExpandList();
        this.cd.markForCheck();
        this.isLoadingRecords = false;
        this.productSku.unsubscribe();
      });
  }

  private isValidLink(urls: any): boolean {
    if (!urls) {
      return false;
    }
    if (typeof urls === 'string') {
      urls = [urls];
    }
    if (!Array.isArray(urls) || urls.length < 1) {
      return false;
    }

    // TypeScript v4.8 doesn't have URL.canParse() documented, but it for sure
    // exists and is fully supported, hence @ts-ignore. [calvin]
    // @see https://developer.mozilla.org/en-US/docs/Web/API/URL/canParse_static
    // @ts-ignore
    return URL.canParse(urls[0]);
  }

  private calculateTotalVariantSkuStocks(rfq: RFQ): void {
    if (!rfq?.variant_sku_stock) {
      return;
    }
    let totalVariantQtyOnHand = 0;
    let totalVariantQtyPending = 0;
    let totalVariantQtyIncoming = 0;
    rfq?.variant_sku_stock.forEach((variantSkuStock: RFQ) => {
      totalVariantQtyOnHand += +(variantSkuStock?.stock?.qty_onhand || 0);
      totalVariantQtyPending += +(variantSkuStock?.stock?.qty_pending || 0);
      totalVariantQtyIncoming += +(variantSkuStock?.stock?.qty_incoming || 0);
    });
    rfq.totalVariantQtyOnHand = totalVariantQtyOnHand;
    rfq.totalVariantQtyPending = totalVariantQtyPending;
    rfq.totalVariantQtyIncoming = totalVariantQtyIncoming;
    rfq.totalVariantQtyAvailable = totalVariantQtyOnHand - totalVariantQtyPending;
    this.cd.detectChanges();
  }

  resetParams(): void {
    this.params = {};
  }

  getQuoteType(id: number) {
    const qt: any = this.rfqService.quoteTypes.find((row) => {
      return row.id === id;
    });

    return qt.text;
  }

  discontinue(rfq: RFQ) {
    let message = 'Discontinue SKU for product ' + rfq.product_name + '?';

    if (rfq.variant_skus_count > 0) {
      message =
        'Discontinuing this master SKU will also discontinue its variant SKUs. Continue?';
    }

    Swal.fire({
      title: 'Confirm Discontinue?',
      text: message,
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Okay',
    }).then((result) => {
      if (result.value) {
        this.rfqService.discontinue(rfq.id, 1).subscribe((resp: any) => {
          this.toastr.success('Successfully discontinued SKU.', 'Success');
        });
      }
    });
  }
  continue(rfq: RFQ) {
    let message = 'Reactivate SKU for product ' + rfq.product_name + '?';

    if (rfq.variant_skus_count > 0) {
      message =
        'Reactivating this master SKU will also reactivate its variant SKUs. Continue?';
    }

    Swal.fire({
      title: 'Confirm Reactivate?',
      text: message,
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Okay',
    }).then((result) => {
      if (result.value) {
        this.rfqService.discontinue(rfq.id, 0).subscribe((resp: any) => {
          this.toastr.success('Successfully reactivated SKU.', 'Success');
        });
      }
    });
  }

  delete(rfq: RFQ) {
    Swal.fire({
      title: 'Confirm Delete?',
      text: 'Delete SKU for product ' + rfq.product_name + '?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: this.translate.instant('BUTTONS.CONFIRM_DELETE_TEXT'),
    }).then((result) => {
      if (result.value) {
        this.rfqService.delete(rfq.id).subscribe(
          (resp: any) => {
            this.toastr.success('Successfully deleted SKU.', 'Success');
            this.getRecords(true);
            this.cd.detectChanges();
          },
          (error: any) => {
            const errorMessage = error?.error?.error;
            if (errorMessage) {
              this.toastr.error(errorMessage);
            }
          },
        );
      }
    });
  }

  deleteSelected() {
    const rfq_ids = [];
    this.checked.forEach((v, idx) => {
      if (v) {
        rfq_ids.push(idx);
      }
    });

    const skus = this.rfqRecord.data.flatMap((rfq: Rfq) => {
      if (rfq_ids.includes(rfq.id)) {
        // If RFQ matches, include parent SKU and selected variant SKUs
        return [
          rfq.internal_sku,
          ...(rfq.variant_skus || [])
            .filter((variant) => rfq_ids.includes(variant.id))
            .map((variant) => variant.internal_sku),
        ];
      }

      // If no matching RFQs found, return only selected variant SKUs
      return (rfq.variant_skus || [])
        .filter((variant) => rfq_ids.includes(variant.id))
        .map((variant) => variant.internal_sku);
    });

    const dialogRef = this.dialog.open(UiMultipleConfirmationDialogComponent, {
      disableClose: true,
      data: {
        title: 'Confirm Delete SKUs?',
        values: skus,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.rfqService
          .bulkDelete(rfq_ids)
          .pipe(takeUntil(this.onDestroy$))
          .subscribe(
            () => {
              this.toastr.success('Successfully deleted SKUs.', 'Success');
              this.getRecords(true);
              this.cd.detectChanges();
              this.clearCheckedState();
            },
            (error: any) => {
              const errorMessage = error?.error?.error;
              if (errorMessage) {
                this.toastr.error(errorMessage);
              }
            },
          );
      }
    });
  }

  trackClientByFn(item: any) {
    return item.id;
  }

  mySalesClient(userAccount) {
    if (!userAccount.go_team_member) {
      return false;
    }

    return userAccount.go_team_member.find((row) => {
      return row.staff_id == this.authService.loginUser.id;
    })
      ? true
      : false;
  }

  transferRfq(rfq: any) {
    const modalRef = this.modalSvc.open(UpdateRfqLocationsComponent, {
      size: 'lg',
    });
    modalRef.componentInstance.rfq = rfq;
    modalRef.result.then(
      (data: any) => {
        if (data && data.locations) {
          rfq.locations = data.locations;
          this.cd.detectChanges();
        }
      },
      (_) => {},
    );
  }

  createRfqForClient() {
    this.modalSvc.open(CreateClientRfqComponent, {
      size: 'lg',
      windowClass: 'xl1024',
    });
  }

  addClient(rfq: RFQ) {
    this.rfqService.setActive(rfq, true);

    const modalRef = this.modalSvc.open(RfqClientsPopupFormComponent, {});
    modalRef.componentInstance.rfqId = rfq.id;
  }

  showDuplicateSku() {
    this.modalSvc.open(SkuDuplicateReportComponent, {
      size: 'lg',
      windowClass: 'xl1024',
    });
  }

  updateSelected() {
    const ids = [];
    const productTypeChecker = [];
    let isProductTypeAlreadyAdded = false;

    this.checked.forEach((v, idx) => {
      if (v) {
        const rfq = this.rfqRecord.data.find((row) => row.id === idx);

        if (rfq) {
          isProductTypeAlreadyAdded = productTypeChecker.includes(rfq.type);

          if (!isProductTypeAlreadyAdded) {
            productTypeChecker.push(rfq.type);
          }
        } else {
          let idExists = false;

          for (const record of this.rfqRecord.data) {
            if (record.variant_skus) {
              for (const variant of record.variant_skus) {
                if (variant.id === idx) {
                  idExists = true;

                  isProductTypeAlreadyAdded = productTypeChecker.includes(
                    variant.type,
                  );

                  if (!isProductTypeAlreadyAdded) {
                    productTypeChecker.push(variant.type);
                  }

                  break;
                }
              }
            }
            if (idExists) {
              break;
            }
          }
        }

        ids.push(idx);
      }
    });

    if (productTypeChecker.length > 1) {
      this.toastr.error(
        'The bulk edit feature allows you to modify multiple products at once, but it requires that you choose a single product type for consistency',
      );

      return;
    }

    const modalRef = this.modalSvc.open(BulkUpdateClientRfqFormComponent, {
      size: 'lg',
      windowClass: 'xl1024',
    });
    modalRef.componentInstance.ids = ids;
    modalRef.componentInstance.productType = productTypeChecker[0];
    modalRef.result.then(
      (data) => {
        this.getRecords(true);
        this.clearCheckedState();
      },
      (_) => {},
    );
  }

  private clearCheckedState(): void {
    this.checked = [];
    this.checkedAll = false;
    this.countChecked();
    this.cd.detectChanges();
  }

  createAdjustmentEntry(rfq: any): void {
    const modalRef = this.modalSvc.open(AdjustmentEntryFormComponent, {
      size: 'lg',
      windowClass: 'xl1024',
    });

    modalRef.componentInstance.rfq = rfq;
    modalRef.componentInstance.isModal = true;
    modalRef.result.then(
      (data) => {
        if (data && data.id) {
          this.rfqService.getById(rfq.id, true).subscribe((resp: any) => {
            if (resp && resp.stock) {
              rfq.stock = resp.stock;
              this.rfqService.updateRowData(rfq);
              this.cd.detectChanges();
            }
          });
        }

        modalRef.componentInstance.inventoryStockLocationUpdate.subscribe(
          (resp) => {
            if (resp) {
              this.getRecords(true);
            }
          },
        );
      },
      (_) => {},
    );
  }

  checkIfCanCreateAdjustmentEntry(r: any): boolean {
    return (
      this.authService.loginUser.prwx === ViewAccountOnly.NO &&
      r &&
      r.mirror_inventory_from_parent !== MirrorInventoryFromParent.YES &&
      (r.type === ProductTypeConstant.PRODUCT || r.type === null)
    );
  }

  exportRfqToPDF(rfq: any) {
    this.exportRfq.exportRfqsToPdfV2([rfq], this.companyLogo);
  }

  exportList(type: ExportType) {
    let loadingMessage = '';
    switch (type) {
      case ExportType.ALTERNATE_SKU_PDF:
        loadingMessage = 'Exporting Alternate Skus, please wait...';
        break;
      case ExportType.MASTER_SKU_EXCEL:
        loadingMessage = 'Exporting Master SKUs, please wait...';
        break;

      case ExportType.FULL_MASTER_SKU_EXCEL:
        loadingMessage = 'Exporting Master SKUs, please wait...';
        break;

      case ExportType.MASTER_SKU_DETAILS_EXCEL:
        loadingMessage = 'Exporting Master SKU Details, please wait...';
        break;

      case ExportType.VARIANT_SKU_DETAILS_EXCEL:
        loadingMessage = 'Exporting Variant SKU Details, please wait...';
        break;

      case ExportType.ALTERNATE_SKU_EXCEL:
        loadingMessage = 'Exporting Alternate SKus, please wait...';
        break;

      case ExportType.VARIANT_SKU_EXCEL:
        loadingMessage = 'Exporting Variant SKus, please wait...';
        break;

      case ExportType.ALTERNATE_SKU_CSV:
        loadingMessage = 'Exporting Alternate SKUs, please wait...';
        break;

      case ExportType.SKU_WITH_CUSTOM_FIELDS_EXCEL:
      case ExportType.SKU_WITH_CUSTOM_FIELDS_CSV:
        loadingMessage = 'Exporting Skus with Custom Fields, please wait...';
        break;

      default:
        loadingMessage = 'Exporting, please wait...';
        break;
    }

    Swal.fire(loadingMessage);
    Swal.showLoading();

    if (this.checkedCount > 0) {
      this.getSkuChecked({ type });
    } else {
      this.getSkusPaginated({ page: 1, skus: [], type });
    }
  }

  exportListTemplate(template: any, fileType: any) {
    const loadingMessage = 'Exporting Skus, please wait...';
    const type = ExportType.EXPORT_TEMPLATE_SKU;

    Swal.fire(loadingMessage);
    Swal.showLoading();

    if (this.checkedCount > 0) {
      this.getSkuCheckedV2({ type, template, fileType });
    } else {
      this.getSkusPaginatedV2({ page: 1, skus: [], type, template, fileType });
    }
  }

  exportTemplate() {
    const modalRef = this.modalSvc.open(ExportTemplateRfqComponent, {
      size: 'lg',
      windowClass: 'xl1024',
    });
    modalRef.componentInstance.export.subscribe((data) => {
      this.exportListTemplate(data.template, data.fileType);
    });
  }

  private getSkuCheckedV2(data: {
    type: ExportType;
    template: any;
    fileType: any;
  }): void {
    const { type, template, fileType } = data;

    const rfq_ids = [];
    this.checked.forEach((v, idx) => {
      if (v) {
        rfq_ids.push(idx);
      }
    });

    const fd = new FormData();
    fd.append('data', JSON.stringify(rfq_ids));
    fd.append('sku_type', 'full_export');

    this.rfqService.exportSelected(fd).subscribe((data) => {
      if (data && data.data) {
        const currentSkus = data.data;
        switch (fileType) {
          case 'pdf':
            this.exportTemplateRfq.exportTemplateToPdf(currentSkus, template);
            break;
          case 'xlsx':
            this.exportTemplateRfq.exportTemplateToExcel(currentSkus, template);
            break;
          case 'csv':
            this.exportTemplateRfq.exportTemplateToCsv(currentSkus, template);
            break;
          default:
            break;
        }
      }
    });
  }

  private getSkusPaginatedV2(data: {
    page: number;
    skus: any[];
    type: ExportType;
    template: any;
    fileType: any;
  }): void {
    const { page, skus, type, template, fileType } = data;
    const params = Object.assign(
      {},
      this.getRecords(false, {
        page: 0,
        paramsOnly: true,
        exportType: type,
      }),
    );
    delete params.order;
    const lastPage = Math.ceil(this.totalRfqsCount / 1000);

    params.page = page;
    params.per_page = 1000;
    params.include_variants = 1;
    delete params.group_variant;
    const filterQueryParams = this.filterQuery;

    this.rfqService.export(params).subscribe((data) => {
      if (data && data.data) {
        const currentSkus = [];
        const sortSkus = [...skus, ...data.data];
        sortSkus.forEach((mainSku) => {
          currentSkus.push(mainSku);
          if (
            mainSku.variant_skus &&
            mainSku.variant_skus.length > 0 &&
            Object.keys(filterQueryParams).length > 0
          ) {
            mainSku.variant_skus.forEach((varSku) => {
              //sortSkus has variants sku data but not all due to filters
              //push when no variant sku in sortSkus match
              const matchSku = sortSkus.find(
                (masterSku) => masterSku.id === varSku.id,
              );
              if (varSku && !matchSku?.id) {
                varSku.parent = {
                  id: mainSku.id,
                  internal_sku: mainSku.internal_sku,
                };
                currentSkus.push(varSku);
              }
            });
          }
        });

        if (page < lastPage && data.data.length > 0) {
          this.getSkusPaginatedV2({
            page: page + 1,
            skus: currentSkus,
            type,
            template,
            fileType,
          });
        } else {
          switch (fileType) {
            case 'pdf':
              this.exportTemplateRfq.exportTemplateToPdf(currentSkus, template);
              break;
            case 'xlsx':
              this.exportTemplateRfq.exportTemplateToExcel(currentSkus, template);
              break;
            case 'csv':
              this.exportTemplateRfq.exportTemplateToCsv(currentSkus, template);
              break;
            default:
              break;
          }
        }
      }
    });
  }

  private getSkuChecked(data: { type: ExportType }): void {
    const { type } = data;

    const rfq_ids = [];
    this.checked.forEach((v, idx) => {
      if (v) {
        rfq_ids.push(idx);
      }
    });

    const fd = new FormData();
    fd.append('data', JSON.stringify(rfq_ids));

    if (type) {
      switch (type) {
        case ExportType.VARIANT_SKU_EXCEL:
          fd.append('sku_type', 'variant');
          break;
        case ExportType.VARIANT_SKU_DETAILS_EXCEL:
          fd.append('sku_type', 'variant');
          break;
        case ExportType.FULL_MASTER_SKU_EXCEL:
          fd.append('sku_type', 'full_export');
          break;
        default:
          fd.append('sku_type', 'parent');
          break;
      }
    }

    this.rfqService.exportSelected(fd).subscribe((data) => {
      if (data && data.data) {
        const currentSkus = data.data;
        switch (type) {
          case ExportType.FULL_MASTER_SKU_EXCEL:
            this.exportRfq.exportFullMasterSkuToExcel(currentSkus);
            break;
          case ExportType.MASTER_SKU_EXCEL:
            this.exportRfq.exportMasterSkuToExcel(currentSkus, false);
            break;
          case ExportType.MASTER_SKU_DETAILS_EXCEL:
            this.exportRfq.exportMasterSkuDetailsToExcel(
              currentSkus,
              false,
              this.tags,
              this.shippingCarriers,
            );
            break;
          case ExportType.VARIANT_SKU_DETAILS_EXCEL:
            this.exportRfq.exportVariantSkuDetailsToExcel(
              currentSkus,
              false,
              this.tags,
              this.shippingCarriers,
            );
            break;
          case ExportType.ALTERNATE_SKU_EXCEL:
            this.exportRfq.exportAlternateSkuToExcel(currentSkus);
            break;
          case ExportType.ALTERNATE_SKU_CSV:
            this.exportRfq.exportRfqsToCsv(currentSkus, true);
            break;
          case ExportType.ALTERNATE_SKU_PDF:
            this.exportRfq.exportRfqsToPdfV2(currentSkus, this.companyLogo, true);
            break;
          case ExportType.PDF:
            this.exportRfq.exportRfqsToPdfV2(
                currentSkus,
                this.companyLogo,
                false,
              );
              break;
          case ExportType.VARIANT_SKU_EXCEL:
            this.exportRfq.exportVariantSkus(currentSkus);
            break;
          default:
            break;
        }
      }
    });
  }

  private getSkusPaginated(data: {
    page: number;
    skus: any[];
    type: ExportType;
  }): void {
    const { page, skus, type } = data;
    const params = Object.assign(
      {},
      this.getRecords(false, {
        page: 0,
        paramsOnly: true,
        exportType: type,
      }),
    );
    delete params.order;
    const pageCount = 1000;
    const lastPage = Math.ceil(this.totalRfqsCount / pageCount);

    params.page = page;
    params.per_page = pageCount;
    params.include_variants = 1;

    this.rfqService.export(params).subscribe((data) => {
      if (data && data.data) {
        const currentSkus = [...skus, ...data.data];
        if (data.data.length === pageCount) {
          this.getSkusPaginated({ page: page + 1, skus: currentSkus, type });
        } else {
          switch (type) {
            case ExportType.FULL_MASTER_SKU_EXCEL:
              this.exportRfq.exportFullMasterSkuToExcel(currentSkus);
              break;
            case ExportType.MASTER_SKU_EXCEL:
              this.exportRfq.exportMasterSkuToExcel(currentSkus, false);
              break;
            case ExportType.MASTER_SKU_DETAILS_EXCEL:
              this.exportRfq.exportMasterSkuDetailsToExcel(
                currentSkus,
                false,
                this.tags,
                this.shippingCarriers,
              );
              break;
            case ExportType.VARIANT_SKU_DETAILS_EXCEL:
              this.exportRfq.exportVariantSkuDetailsToExcel(
                currentSkus,
                false,
                this.tags,
                this.shippingCarriers,
              );
              break;
            case ExportType.ALTERNATE_SKU_EXCEL:
              this.exportRfq.exportAlternateSkuToExcel(currentSkus);
              break;
            case ExportType.ALTERNATE_SKU_CSV:
              this.exportRfq.exportRfqsToCsv(currentSkus, true);
              break;
            case ExportType.ALTERNATE_SKU_PDF:
              this.exportRfq.exportRfqsToPdfV2(currentSkus, this.companyLogo, true);
              break;
            case ExportType.PDF:
              this.exportRfq.exportRfqsToPdfV2(
                currentSkus,
                this.companyLogo,
                false,
              );
              break;
            case ExportType.VARIANT_SKU_EXCEL:
              this.exportRfq.exportVariantSkus(currentSkus);
              break;
            case ExportType.SKU_WITH_CUSTOM_FIELDS_EXCEL:
              this.exportRfq.exportWithCustomFields(
                currentSkus,
                this.customFields,
                FileTypeConstant.XLSX,
              );
              break;
            case ExportType.SKU_WITH_CUSTOM_FIELDS_CSV:
              this.exportRfq.exportWithCustomFields(
                currentSkus,
                this.customFields,
                FileTypeConstant.CSV,
              );
              break;
            default:
              break;
          }
        }
      }
    });
  }

  exportAlternateSku(exportType: string): void {
    const paramsObject = this.getRecords(false, {
      page: 0,
      paramsOnly: true,
      exportType: exportType,
    });
    paramsObject.exportType = exportType;

    if (this.checkedCount > 0) {
      const rfqIds = [];
      this.checked.forEach((value, index) => {
        if (value) {
          rfqIds.push(index);
        }
      });
      paramsObject.rfqIds = rfqIds.join(',');
    }

    this.loadingDialogService.show(
      'Creating ' + exportType.toLocaleUpperCase() + ', please wait...',
    );
    this.rfqApiService.exportAlternateSku({ ...paramsObject }).subscribe({
      next: (resp: any) => {
        FileSaver.saveAs(resp, 'alternate-sku.' + exportType);
        this.loadingDialogService.close();
      },
      error: () => {
        this.loadingDialogService.close();
        this.loadingDialogService.showDialogMessage('Error Export');
      },
    });
  }

  viewPendingRfqStockDetails(rfq: RFQ) {
    const modalRef = this.modalSvc.open(SkuStockDetailsComponent, {
      size: 'lg',
      windowClass: 'xl1024',
    });
    modalRef.componentInstance.rfq = rfq;
    modalRef.componentInstance.qtyType = InventoryStockType.PENDING;
  }

  viewIncomingRfqStockDetails(rfq: RFQ) {
    this.dialog.open(RfqInventoryOrdersTableComponent, {
      data: {
        rfq,
      },
      width: DialogConfig.Size.LARGE,
      disableClose: true,
    });
  }

  addUnderNewMasterSku(): void {
    const rfq_ids = [];
    this.checked.forEach((v, idx) => {
      if (v) {
        rfq_ids.push(idx);
      }
    });

    const firstRfqId =
      rfq_ids.find((rfq) => rfq === this.firstCheckedRfqId) ??
      rfq_ids[rfq_ids.length - 1];

    const modalRef = this.modalSvc.open(ConsolidateMasterSkuComponent, {});
    modalRef.componentInstance.rfq_ids = rfq_ids;
    modalRef.componentInstance.firstSelectedRfqId = firstRfqId;
    modalRef.result.then(
      () => {
        this.checkedAll = false;
        this.checkAll();
        this.rfqService.refreshList();
      },
      (error) => {},
    );
  }

  dynamicQtyStockString(suffix: string): string {
    const order = this.params?.order;
    const sort = this.params?.sort;

    if (
      this.featureToggleService.isActive('red_CS-5115_sku_stocks_page_query_update')
    ) {
      return suffix;
    }

    if (order && sort) {
      if (order.search(SkuStockSortType.PARENT)) {
        if (sort === StockSortingType.ASC) {
          return SkuStockSortType.PARENT + '_' + suffix;
        } else {
          return SkuStockSortType.VARIANT + '_' + suffix;
        }
      }

      if (order.search(SkuStockSortType.VARIANT)) {
        if (sort === StockSortingType.ASC) {
          return SkuStockSortType.VARIANT + '_' + suffix;
        } else {
          return SkuStockSortType.PARENT + '_' + suffix;
        }
      }
    }

    return SkuStockSortType.PARENT + '_' + suffix;
  }

  private updateFilters() {
    const productTypeFilterLength: number = this.filterConfiguration.filter(
      (item) => item?.label === 'Product Type',
    ).length;

    //trigger push once only
    if (productTypeFilterLength === 0) {
      this.filterConfiguration.push({
        id: 'product_type',
        query: 'product_type',
        type: 'select',
        label: 'Product Type',
        options: [
          {
            value: ProductTypeConstant.PRODUCT,
            label: ProductTypeConstant.PRODUCT,
          },
          { value: ProductTypeConstant.KIT, label: ProductTypeConstant.KIT },
        ],
      });
    }

    const warehouseGroupFilterExists = this.filterConfiguration.some(
      (filter) => filter?.id === 'warehouse_group',
    );

    if (!warehouseGroupFilterExists) {
      this.filterConfiguration.push({
        id: 'warehouse_group',
        type: 'warehouseGroup',
        label: 'Warehouse Group',
        query: 'warehouseGroup',
      });
    }
  }

  promoteVariantToMasterSku(rfq?: RFQ): void {
    const rfqIds = [];
    if (rfq) {
      rfqIds.push(rfq.id);
    } else {
      this.checked.forEach((value: any, idx: number) => {
        if (value) {
          rfqIds.push(idx);
        }
      });
      if (rfqIds.length === 0) {
        return;
      }
    }
    this.rfqService
      .promoteVariantToMasterSku({ rfqIds: rfqIds })
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (resp: any) => {
          this.toastr.success(
            'Successfully promoted Variant SKU to Master SKU',
            'Success',
          );
          this.getRecords(true);
        },
        (error) => {
          this.toastr.error(error?.error?.error);
        },
      );
  }

  async toggleRfqStarredState(rfq: any): Promise<void> {
    const params: any = {};
    if (parseInt(rfq.starred) === 0) {
      const { value: notes } = await Swal.fire({
        title: rfq.product_name,
        input: 'textarea',
        inputPlaceholder: 'Type your notes here...',
        inputAttributes: {
          'aria-label': 'Type your notes here',
        },
        showCancelButton: true,
      });

      if (notes) {
        params.starred_notes = notes;
      } else {
        params.starred_notes = '';

        return;
      }
    }

    this.toggleRfqStarred = this.rfqService
      .toggleRfqStarredState(params, rfq.id)
      .subscribe(
        (resp) => {
          this.toastr.success(resp);
          rfq.starred = parseInt(rfq.starred) === 0 ? 1 : 0;
          rfq.starred_notes = params.starred_notes;
          this.rfqService.updateRowData(rfq);
          this.cd.detectChanges();
        },
        (error) => {
          this.toastr.error(error);
        },
      );
  }

  private updateColumns(): void {
    if (this.featureToggleService.featureEnabled(EFeatureFlag.CUSTOM_FIELDS)) {
      this.columns['customFields'] = { label: 'Custom Fields', active: false };
    }
  }

  private initFeatureFlags(): void {
    this.featureFlags = this.activeRoute.snapshot.data['featureFlags'];
  }

  private loadCustomFields(): void {
    this.customFieldApiService
      .getAll({
        customFieldObject: ECustomFieldObject.RFQ,
      })
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((customFields) => {
        if (customFields) {
          this.customFields = customFields;
          this.addCustomFieldsToFilterConfig();
        }
      });
  }

  private addCustomFieldsToFilterConfig(): void {
    // Remove existing custom field filters to avoid duplicates
    const baseFilters = this.filterConfiguration.filter(
      (filter) => filter.type !== 'customField'
    );

    // Create custom field filters
    const customFieldFilters: DynamicFilterConfig[] = this.customFields.map((customField) => {
      // Convert field label to API parameter format (spaces to underscores)
      const fieldName = customField.label.replace(/\s+/g, '_');
      
      return {
        id: `custom_field_${customField.id}`,
        type: 'customField',
        label: customField.label,
        query: fieldName, // Use field name instead of custom_field_${id}
        customField: {
          id: customField.id,
          label: customField.label,
          type: customField.type,
          options: customField.options,
        },
      } as DynamicFilterConfig;
    });

    // Create new array reference to trigger change detection
    this.filterConfiguration = [...baseFilters, ...customFieldFilters];
  }

  private initLogoFromSettings(): Observable<any> {
    return this.settingsSvc.getKeyValue(SettingConstant.COMPANY_LOGO_KEY).pipe(
      tap((response) => {
        if (response) {
          this.getLogoKeyFromSettings(response).subscribe();
        }
      }),
      takeUntil(this.onDestroy$),
    );
  }

  private getLogoKeyFromSettings(filename: string): Observable<any> {
    return this.settingsSvc.getProfileLogo(filename).pipe(
      tap((response) => {
        if (response) {
          if (filename.endsWith('.webp')) {
            this.companyLogo = 'data:image/webp;base64,' + response;
          } else {
            // Default to PNG if not WebP
            this.companyLogo = 'data:image/png;base64,' + response;
          }
        }
      }),
      takeUntil(this.onDestroy$),
    );
  }

  get ftSupplierSourceSku(): boolean {
    if (this.featureFlags?.hasOwnProperty('ftSupplierSourceSku')) {
      return this.featureFlags['ftSupplierSourceSku'];
    }

    return false;
  }
}
